import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/confirmation')({
  component: () => <Navigate to='/onboarding' />,
})
